let language = {
    CART_PROGRESSBAR_PRODUCT:"Products",
    CART_PROGRESSBAR_SHIP:"Shipping",
    CART_PROGRESSBAR_PAYMENT:"Payment",
    
}

export { language }